import { call, put } from 'redux-saga/effects';
import { picoAPIHelper } from '@piconetworks/pkg-network-middleware';
import { FEATURE_FLAGS } from '@piconetworks/pkg-endpoints';

function getFeatureFlags(_ref) {
  var types = _ref.types,
    publisherId = _ref.publisherId,
    _ref$guest = _ref.guest,
    guest = _ref$guest === void 0 ? false : _ref$guest,
    userId = _ref.userId;
  return function* () {
    try {
      var _yield$call = yield call(picoAPIHelper, {
          url: "" + FEATURE_FLAGS() + (guest ? '/guest' : ''),
          method: 'post',
          headers: {
            publisherid: publisherId
          },
          data: {
            user_id: userId
          }
        }),
        data = _yield$call.data;
      if (data) {
        yield put({
          type: types.GET_FEATURE_FLAGS_SUCCESS,
          payload: Object.assign({}, data)
        });
      }
    } catch (e) {
      yield put({
        type: types.GET_FEATURE_FLAGS_ERRORS,
        error: e
      });
    }
  }();
}

export { getFeatureFlags as default };
//# sourceMappingURL=getFeatureFlags.js.map
